import { Response } from "./constant/Response";
import { isNotEmpty } from "./Utils";

export function extractCookie(name) {
    var match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
    return match && isNotEmpty(match[2]) ? match[2] : "";
}

export function getRequestOption(url, method, body, header, option) {
    var token = extractCookie("token");
    var requestHeader = {
        "Content-Type": "application/json",
        Accept: "application/json",
        ...header,
    };
    if (isNotEmpty(token)) {
        requestHeader["Authorization"] = `Bearer ${token}`;
    }
    if (body instanceof FormData) {
        delete requestHeader["Content-Type"];
        delete requestHeader["Accept"];
    }
    return {
        url: url,
        method: method || "GET",
        body: body,
        headers: requestHeader,
        ...option,
    };
}

export function send(
    name,
    { url, method = "GET", body = null, header = {}, option = {} }
) {
    var params = getRequestOption(url, method, body, header, option);

    return function (dispatch) {
        dispatch({ type: `${name}_REQUEST` });
        var request = fetch(params?.url, params)
            .then((response) => {
                const serverTime = response?.headers?.get("Date");
                if (isNotEmpty(serverTime)) {
                    dispatch({
                        type: "SET_SERVERTIME",
                        payload: serverTime,
                    });
                }
                switch (response.status) {
                    case Response.ok:
                    case Response.expectedError:
                    case Response.badRequest:
                    case Response.movedTemporary:
                    case Response.serviceUnavailable:
                        dispatch({
                            type: `${name}_SUCCESS`,
                            payload: response,
                        });
                        break;
                    default:
                        dispatch({
                            type: `${name}_FAIL`,
                            payload: response,
                        });
                        break;
                }
                return response;
            })
            .catch((error) => {
                dispatch({
                    type: `${name}_FAIL`,
                    payload: error,
                });
                console.log("send request failed", error);
            });
        return Promise.resolve(request);
    };
}


export function sendV20(name,{ url, method = "GET", body = null, header = {}, option = {} }) {
    var params = {
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(header),
        url: url
    }

    return function (dispatch) {
        dispatch({ type: `${name}_REQUEST` });
        var request = fetch(params?.url, params)
            .then((response) => {

                switch (response.status) {
                    case Response.ok:
                    case Response.expectedError:
                    case Response.badRequest:
                    case Response.movedTemporary:
                    case Response.serviceUnavailable:
                        dispatch({
                            type: `${name}_SUCCESS`,
                            payload: response,
                        });
                        break;
                    default:
                        dispatch({
                            type: `${name}_FAIL`,
                            payload: response,
                        });
                        break;
                }
                return response;
            })
            .catch((error) => {

                dispatch({
                    type: `${name}_FAIL`,
                    payload: error,
                });
                console.log("send request failed", error);
            });
        return Promise.resolve(request);
    };
}

export function sendV30({ url, method = "GET", body = null, header = {}, option = {} }) {
    var params = {
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(header),
        url: url
    }

    return function () {

        var request = fetch(params?.url, params)
            .then((response) => {


                return response;
            })
            .catch((error) => {


                console.log("send request failed", error);
            });
        return Promise.resolve(request);
    };
}

/**
 * @argument: array of json object that created by getRequestOption method.
 * @return: a Promise of the response of all requests.
 * @example: dispatch(sendAll(option1, option2, ...))
 */
export function sendAll() {
    return function (dispatch) {
        dispatch({ type: "_REQUEST" });
        var requestList = arguments.map((option) => fetch(option.url, option));
        return Promise.all(requestList)
            .then((response) => {
                dispatch({ type: "_SUCCESS" });
                return response;
            })
            .catch((error) => {
                dispatch({ type: "_FAIL" });
                console.log("send request failed", error);
            });
    };
}
